/* PLAKTON · pk-legal.js — maqueta de textos legales y de ayuda */
(function () {
  'use strict';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Políticas de Shopify: mete el contenido en la maqueta PK */
  function mountPolicy() {
    var box = document.querySelector('.shopify-policy__container');
    var tpl = document.getElementById('pk-legal-shell');
    if (!box || !tpl || box.classList.contains('pk-legal-done')) return null;
    var titleEl = box.querySelector('.shopify-policy__title h1, .shopify-policy__title, h1');
    var bodyEl = box.querySelector('.shopify-policy__body .rte, .shopify-policy__body') || box;
    var frag = tpl.content.cloneNode(true);
    var root = frag.querySelector('[data-pk-legal]');
    root.querySelector('[data-pk-legal-title]').textContent = titleEl ? titleEl.textContent.trim() : document.title;
    var target = root.querySelector('[data-pk-legal-body]');
    while (bodyEl.firstChild) target.appendChild(bodyEl.firstChild);
    box.parentNode.insertBefore(frag, box);
    box.classList.add('pk-legal-done');
    document.documentElement.classList.remove('pk-legal-policy');
    return document.querySelector('[data-pk-legal]');
  }

  function slug(t, used) {
    var s = (t || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60) || 'seccion';
    var base = s, n = 2;
    while (used[s]) s = base + '-' + n++;
    used[s] = 1;
    return s;
  }

  function enhance(root) {
    if (!root || root.dataset.pkReady) return;
    root.dataset.pkReady = '1';
    var body = root.querySelector('[data-pk-legal-body]');
    if (!body) return;

    /* Títulos «falsos» de los textos pegados (negrita, subrayado, listas de un punto) → h2 */
    function toH2(el, text) {
      var h = document.createElement('h2');
      h.textContent = text.replace(/\s+/g, ' ').trim();
      el.parentNode.replaceChild(h, el);
    }
    function onlyStrong(el) {
      var t = el.textContent.trim();
      if (!t || t.length > 110) return false;
      var b = el.querySelector('strong, b');
      return !!b && b.textContent.trim() === t;
    }
    var heads = body.querySelectorAll('h2');
    if (heads.length < 2) {
      var strongCands = [], n = 0;
      body.querySelectorAll('p, ol, ul').forEach(function (el) {
        if (el.closest('table')) return;
        if (el.tagName === 'P') {
          var t = el.textContent.trim();
          if (onlyStrong(el) && (el.querySelector('u') || /^\d+[\.\)]\s/.test(t))) strongCands.push([el, t]);
        } else if (el.children.length === 1 && el.children[0].tagName === 'LI' && onlyStrong(el.children[0])) {
          n = el.tagName === 'OL' && el.getAttribute('start') ? Number(el.getAttribute('start')) : n + 1;
          var lt = el.children[0].textContent.trim();
          strongCands.push([el, el.tagName === 'OL' && !/^\d/.test(lt) ? n + '. ' + lt : lt]);
        }
      });
      if (strongCands.length >= 2) {
        strongCands.forEach(function (c) { toH2(c[0], c[1]); });
      } else {
        body.querySelectorAll('p').forEach(function (p) {
          var t = p.textContent.trim();
          if (p.children.length === 1 && onlyStrong(p) && t.length > 2 && t.length < 90 && !/[:.]$/.test(t)) toH2(p, t);
        });
      }
      heads = body.querySelectorAll('h2');
    }
    if (heads.length < 2) heads = body.querySelectorAll('h2, h3');

    /* Tablas con scroll horizontal en móvil */
    body.querySelectorAll('table').forEach(function (t) {
      if (t.parentNode.classList.contains('pk-legal__table')) return;
      var w = document.createElement('div'); w.className = 'pk-legal__table';
      t.parentNode.insertBefore(w, t); w.appendChild(t);
    });

    /* Tiempo de lectura */
    var read = root.querySelector('[data-pk-legal-read]');
    if (read) {
      var words = (body.textContent || '').trim().split(/\s+/).length;
      var min = Math.max(1, Math.round(words / 220));
      read.textContent = (read.getAttribute('data-label') || '__N__ min').replace('__N__', min);
    }

    /* Imprimir */
    var pr = root.querySelector('[data-pk-legal-print]');
    if (pr) pr.addEventListener('click', function () { window.print(); });

    /* Índice */
    var box = root.querySelector('[data-pk-legal-tocbox]');
    var list = root.querySelector('[data-pk-legal-toc]');
    if (!box || !list || heads.length < 2) return;
    var used = {}, links = [];
    heads.forEach(function (h) {
      if (!h.id) h.id = slug(h.textContent, used); else used[h.id] = 1;
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + h.id;
      a.textContent = h.textContent.trim().replace(/\s+/g, ' ');
      a.addEventListener('click', function (e) {
        e.preventDefault();
        h.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (history.replaceState) history.replaceState(null, '', '#' + h.id);
        if (window.matchMedia('(max-width: 989px)').matches) box.open = false;
      });
      li.appendChild(a); list.appendChild(li); links.push(a);
    });
    box.hidden = false;
    box.open = !window.matchMedia('(max-width: 989px)').matches;

    /* Sección activa + barra de progreso */
    var bar = document.createElement('div');
    bar.className = 'pk-legal__progress';
    document.body.appendChild(bar);
    var ticking = false;
    function update() {
      ticking = false;
      var r = body.getBoundingClientRect();
      var total = r.height - window.innerHeight * 0.6;
      var p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 1;
      bar.style.transform = 'scaleX(' + p + ')';
      var cur = 0;
      for (var i = 0; i < heads.length; i++) { if (heads[i].getBoundingClientRect().top < 160) cur = i; }
      links.forEach(function (a, k) { a.classList.toggle('is-active', k === cur); });
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  }

  function init() {
    var root = mountPolicy() || document.querySelector('[data-pk-legal]');
    enhance(root);
    if (location.hash) { var t = document.getElementById(location.hash.slice(1)); if (t) setTimeout(function () { t.scrollIntoView(); }, 60); }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', function (e) { enhance(e.target.querySelector('[data-pk-legal]')); });
})();
